/** Droppable id for Scene mount (`Scene.jsx`). */
export const SCENE_LIBRARY_DROPZONE_ID = "scene-library-dropzone";

/** Droppable id for mobile “cancel drag” pill (`MobileLibraryDragChrome.jsx`, `Scene.jsx`). */
export const MOBILE_LIBRARY_DRAG_CANCEL_DROP_ID = "mobile-library-drag-cancel";
